import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
	meta: {
      title: "登录售票端",
      title1: "Terminal de Venta",
    },
    hidden: true,
  },
  { path: "/404", component: () => import("@/views/404"), hidden: true },
  {
    path: "",
    component: Layout,
    redirect: "/home",
    meta: {
      title: "售票窗口",
      title1: "Venta",
      icon: "s-home",
    },
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("@/views/home/index"),
        meta: {
          title: "售票窗口",
          title1: "Venta",
          icon: "s-home",
        },
      },
    ],
  },
  {
    path: "",
    component: Layout,
    redirect: "/orderInquiry",
    meta: { title: "订单查询", title1: "Consulta de pedido", icon: "s-order" },
    children: [
      {
        path: "orderInquiry",
        name: "orderInquiry",
        component: () => import("@/views/orderInquiry/index"),
        meta: {
          title: "订单查询",
          title1: "Consulta de pedido",
          icon: "s-order",
        },
      },
    ],
  },
   {
    path: "",
    component: Layout,
    redirect: "/orderdel",
    meta: { title: "删除查询", title1: "Pedidos eliminados", icon: "s-order" },
    children: [
      {
        path: "orderdel",
        name: "orderdel",
        component: () => import("@/views/orderdel/index"),
        meta: {
          title: "删除查询",
          title1: "Pedidos eliminados",
          icon: "s-order",
        },
      },
    ],
  },
  {
    path: "",
    component: Layout,
    redirect: "/winningCheck",
    meta: { title: "兑奖查询", title1: "Estado de pago", icon: "s-claim" },
    children: [
      {
        path: "winningCheck",
        name: "winningCheck",
        component: () => import("@/views/winningCheck/index"),
        meta: {
          title: "兑奖订单",
          title1: "Estado de pago",
          icon: "s-claim",
        },
      },
    ],
  },
  {
    path: "",
    component: Layout,
    redirect: "/statistics",
    meta: {
      title: "累计统计",
      title1: "Estadísticas",
      icon: "s-data",
    },
    children: [
      {
        path: "statistics",
        name: "statistics",
        component: () => import("@/views/statistics/index"),
        meta: {
          title: "累计统计",
          title1: "Estadísticas",
          icon: "s-data",
        },
      },
    ],
  },
  /*{
    path: "",
    component: Layout,
    redirect: "/setUp",
    meta: { title: "设置", title1: "Configuración", icon: "s-tools" },
    children: [
      {
        path: "setUp",
        name: "setUp",
        component: () => import("@/views/setUp/index"),
        meta: { title: "设置", title1: "Configuración", icon: "s-tools" },
      },
    ],
  },*/
];

export const asyncRouterMap = [{ path: "*", redirect: "/404", hidden: true }];

export default new Router({
  mode: "history", //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
  base: "/web",
});



// WEBPACK FOOTER //
// ./src/router/index.js